module.exports = __webpack_public_path__ + "img/DE00769.27acc12f.png";